import { AxiosInstance } from "axios";
import FundInterface from "@/types/app/funds";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import ProductFund from "@/types/app/productFunds";
import compareTo from "./compareTo";
import Endpoint from "./endpoint";


export async function getProductFunds(api: AxiosInstance): Promise<VuetifySelectItems[]> {
  const endpoint = new Endpoint();
  const response = await api.get(`${endpoint.productFund}?hasInvestment=true`);
  const productFunds = response.data as ProductFund[];
  const productFundsOrdened = productFunds.sort((a, b) =>
    compareTo(a.fundSiteName, b.fundSiteName)
  );

  const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
    text: productFund.fundSiteName,
    value: productFund.fundId,
    data: productFund,
  }));

  return itemsForVuetifySelect;
}